export const draftColumns = [
  { id: "margin", title: "Margin" },
  { id: "price", title: "Price" },
  { id: "pack_size", title: "Pack size" },
  { id: "warehouse_location", title: "Warehouse location" },
  { id: "min", title: "Min quantity" },
  { id: "supplier_sku", title: "Vendor / supplier SKU" },
] as const;

export type DraftColumn = (typeof draftColumns)[number];

export const orderedColumns = [
  { id: "currently_available", title: "Available", tooltipContent: "Currently available at the destination" },
] as const;
